
import React, { useState } from "react";
import { useNavigate, } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { validateForm } from "utils/validation";
import { RoomCheckinFormRules } from "validation/ValidationRules";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import {
    createRoomBooking,
    getAllPaymentMethods,
    getAllRoomTypes,
    getChargePercent,
    getRoomBookingTypes
} from "adminApi/RoomCheckInApi/RoomCheckIn";
import CreateRoomCheckInForm from "./Components/CreateRoomCheckInForm";
import useFetchAllData from "Hooks/useFetchAllData";

// IMPORT YOUR FIXED JSON AS-IS
import fields from "../json/RoomCheckInFields.json";

const { form_data } = fields;


// EditRoomCheckIn.jsx

const { Reservation_Details, RoomFields, extraFields, Payment_Details, Advance_Details, Rent_Info } = form_data

// Build flat form fields as empty strings
const data = [...Reservation_Details, ...Payment_Details, ...Advance_Details]
const roomFields = [...RoomFields, ...extraFields, ...Rent_Info]

// Convert field name arrays to { fieldName: "" } objects
const flatInitialValues = Object.fromEntries(
    data.map((f) => [
        f.name,
        f.name === "checkin_date"
            ? new Date().toISOString().split("T")[0] // YYYY-MM-DD
            : ""
    ])
);

// Convert room field names to one empty room object
const emptyRoom = {
    ...Object.fromEntries(roomFields.map((f) => [f.name, ""])),
    capacity: ""
};

const initialValues = {
    ...flatInitialValues,

    rooms: [emptyRoom]
}

// ---------------------------------------
// MAIN COMPONENT
// ---------------------------------------

const CreateRoomCheckIn = () => {

    const navigate = useNavigate();
    const [ChildrenMinAge, setChildrenMinAge] = useState(null);
    const [ChildrenMaxAge, setChildrenMaxAge] = useState(null);

    const [loadingFetch, setLoadingFetch] = useState(false);

    // Dropdown data
    const { data: bookingTypes = [] } = useFetchAllData(getRoomBookingTypes);
    const { data: roomTypesOption = [] } = useFetchAllData(getAllRoomTypes);
    const { data: paymentMethodTypesOption = [] } = useFetchAllData(getAllPaymentMethods);
    const { data: taxConfig } = useFetchAllData(getChargePercent);

    // KEEP JSON EXACT — JUST CLONE IT
    const clonedInitialValues = {
        ...initialValues,

        rooms: [{ ...initialValues.rooms[0] }],
    };

    const { values, setValues, errors, handleChange, setErrors } =
        useFormChange(clonedInitialValues, RoomCheckinFormRules);

    // ---------------------------------------
    // SUBMIT HANDLER
    // ---------------------------------------
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();

            // Send all keys except rooms
            Object.entries(formValues).forEach(([key, val]) => {
                if (key !== "rooms") formData.append(key, val ?? "");
            });

            formData.append("rooms", JSON.stringify(formValues.rooms));

            return createRoomBooking({ data: formData });
        },
        (vals) => {
            const v = { ...vals };
            delete v.booking_status;

            /** REMOVE NON-EDITABLE FIELDS */
            delete v.customer_name;
            delete v.customer_phone;
            delete v.customer_email;
            delete v.customer_address;
            delete v.full_guest_name;

            /** VALIDATE */
            const validationErrors = validateForm(v, RoomCheckinFormRules);
            setErrors(validationErrors);
            return validationErrors;
        },
        () => navigate(-1),
        "Room Booking Created Successfully"
    );



    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}

            {!loadingFetch && (
                <CreateRoomCheckInForm
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    handleChange={handleChange}
                    handleSubmit={(e) => handleSubmit(e, values)}
                    loading={loadingSubmit}
                    bookingTypesOptions={bookingTypes}
                    roomTypesOption={roomTypesOption}
                    paymentMethodTypesOption={paymentMethodTypesOption}
                    taxConfig={taxConfig}
                    initialValues={initialValues}
                    form_data={form_data}
                    ChildrenMinAge={ChildrenMinAge}
                    ChildrenMaxAge={ChildrenMaxAge}
                    emptyRoom={[...initialValues.rooms]}
                    roomFields={roomFields}
                    setChildrenMinAge={setChildrenMinAge}
                    setChildrenMaxAge={setChildrenMaxAge}
                />
            )}
        </>
    );
};

export default CreateRoomCheckIn;